export default class DocumentSearch {
    constructor() {

        this.jobNumber = ''
        this.docTitle = ''
        this.date = '';
    }
}